import React, {useEffect} from 'react';
import {motion, useAnimation} from 'framer-motion';
import {useInView} from 'react-intersection-observer';

export default function Skills(animation) {
  const controls = useAnimation();
  const {ref, inView} = useInView({threshold: 0.3});
  const {animation: aniprops} = animation;

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
    if (!inView) {
      controls.start('hidden');
    }
  }, [controls, inView]);

  return (
    <section ref={ref} className='skills section' id='skills'>
      <motion.div
        initial='hidden'
        animate={controls}
        variants={aniprops}
        className='wrapper'
      >
        <span className='section__subtitle'>My abilities</span>
        <h2 className='section__title'>My experience</h2>
        <div className='skills__container-flex'>
          <div className='skills__container container grid'>
            <div className='skills__content'>
              <h3 className='skills__title'>Frontend Developer</h3>
              <div className='skills__box'>
                <div className='skills__group'>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>HTML</h3>
                      <span className='skills__level'>Advanced</span>
                    </div>
                  </div>

                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>CSS</h3>
                      <span className='skills__level'>Advanced</span>
                    </div>
                  </div>

                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>Javascript</h3>
                      <span className='skills__level'>Intermediate</span>
                    </div>
                  </div>
                </div>
                <div className='skills__group'>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>Bootstrap</h3>
                      <span className='skills__level'>Basic</span>
                    </div>
                  </div>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>Git</h3>
                      <span className='skills__level'>Basic</span>
                    </div>
                  </div>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>React</h3>
                      <span className='skills__level'>Intermediate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='skills__content'>
              <h3 className='skills__title'>Backend Developer</h3>
              <div className='skills__box'>
                <div className='skills__group'>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>PHP</h3>
                      <span className='skills__level'>Basic</span>
                    </div>
                  </div>

                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>MySQL</h3>
                      <span className='skills__level'>Intermediate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='skills__container-center'>
            <div className='skills__content'>
              <h3 className='skills__title'>Designer</h3>
              <div className='skills__box'>
                <div className='skills__group'>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>
                        Adobe <br /> Illustrator
                      </h3>
                      <span className='skills__level'>Advanced</span>
                    </div>
                  </div>

                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>
                        Adobe
                        <br /> Photoshop
                      </h3>
                      <span className='skills__level'>Basic</span>
                    </div>
                  </div>

                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>
                        Adobe
                        <br /> Animate
                      </h3>
                      <span className='skills__level'>Intermediate</span>
                    </div>
                  </div>
                </div>
                <div className='skills__group'>
                  <div className='skills__data'>
                    <i className='bx bxs-badge-check'></i>
                    <div>
                      <h3 className='skills__name'>Figma</h3>
                      <span className='skills__level'>Intermediate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
